import {GetBannerResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/banner/service.types';

const HERO_IMAGE =
  'https://cdn.aboutstatic.com/file/8b52d4f5eccc56d4b0e211d0f04531e0.jpg?quality=75&height=430&width=860';

const PRODUCT_IMAGE_URLS = [
  'https://cdn.aboutstatic.com/file/4572f144890ab45c9000f8a4dedaa215.png?quality=75',
  'https://cdn.aboutstatic.com/file/91ff73682773ed3e0a5736fbb0e7e9e8?width=200&quality=75',
  'https://cdn.aboutstatic.com/file/5bd722080ccfa4531d1796b17a28bc9e?width=200&quality=75',
  'https://cdn.aboutstatic.com/file/4572f144890ab45c9000f8a4dedaa215.png?quality=75',
];

export const wishlistBannerMock: GetBannerResponse = {
  banner: {
    variant: {
      $case: 'highlightBanner',
      highlightBanner: {
        headline: 'Up to -40% extra',
        subline: 'End of season sale only this week',
        colors: {
          foregroundColor: {hex: '#FFFFFF'},
          backgroundColor: {hex: '#3B0764'},
        },
        gradientColors: ['#E879F9', 'rgba(232, 121, 249, 0)'],
        media: {
          backgroundColor: '#3B0764',
          variant: {
            $case: 'image',
            image: {
              url: HERO_IMAGE,
              description: 'Banner hero',
              external: false,
            },
          },
        },
        cta: {
          label: 'Shop now',
          colors: {
            foregroundColor: {hex: '#3B0764'},
            backgroundColor: {hex: '#FFFFFF'},
          },
        },
        countdown: {endsAt: new Date(Date.now() + 4 * 24 * 3600 * 1000)},
        infoIcon: {
          headline: 'About this campaign',
          content: {
            text: 'This sale runs only this week. Discounts apply automatically at checkout.',
          },
        },
        productImages: PRODUCT_IMAGE_URLS.map((src, i) => ({
          src,
          description: `Product ${i + 1}`,
          isEnclosed: false,
        })),
        isAd: false,
        target: {url: '/sale', external: false},
        tracker: {
          promotionId: 'mock-wishlist-banner',
          promotionName: 'Mock Wishlist Banner',
          creativeName: 'highlight',
          creativeSlot: 'wishlist-header',
        },
      },
    },
  },
};
